import { collapseDuplicateUploadsPath } from '@/shared/lib/media-proxy'

export { resolveMediaDisplayUrl } from '@/shared/lib/media-proxy'

function stripNilPathPrefix(url: string): string {
  let s = url.trim()
  while (s.startsWith('<nil>/')) {
    s = s.slice('<nil>/'.length)
  }
  return collapseDuplicateUploadsPath(s)
}

export function assetMediaUrl(asset: { media_url?: string; url?: string } | null | undefined): string {
  if (!asset) return ''
  return stripNilPathPrefix(String(asset.media_url ?? asset.url ?? ''))
}

function urlLooksAudio(url: string): boolean {
  return /\.(mp3|wav|ogg|m4a|aac|flac|opus)(\?|#|$)/i.test(url)
}

function urlLooksVideo(url: string): boolean {
  return /\.(mp4|mov|m4v|avi|webm)(\?|#|$)/i.test(url)
}

/** 根据 media_kind 或 URL 推断预览类型（审片 / 时间线等复用） */
export function inferMediaKind(
  mediaKind: string | null | undefined,
  url: string | null | undefined,
): 'image' | 'video' | 'audio' | 'other' {
  const src = String(url ?? '').trim().toLowerCase()
  const kind = String(mediaKind ?? '').trim().toLowerCase()
  if (urlLooksVideo(src)) return 'video'
  if (urlLooksAudio(src)) return 'audio'
  if (/\.(png|jpe?g|gif|webp|svg|bmp)(\?|#|$)/i.test(src)) return 'image'
  if (kind === 'video') return 'video'
  if (kind === 'audio') return 'audio'
  if (kind === 'image') return 'image'
  return 'other'
}
